import object from '@mailobj-browser/front/js/utils/object.js'
import file from '../fs/file.js'
import path from '../path/resolve.js'
import defer from '../network/defer.js'
import attach from '../actions/attach.js'

const intentName = 'android.intent.action.SEND_MULTIPLE'
export default object(null, {
  action: intentName,
  task: async (intent) => {
    console.log(`Managing ${intentName}`)
	
    const promises = []
	const { clipItems } = intent
    /* get input */
	for (const item of clipItems) {
      promises.push(new Promise( async r => {
        const itemPath = await path(item.uri)
        const itemFile = await file(itemPath)
        r(itemFile)
      }))
    }
    /* process action when ready */
    Promise.all(promises)
      .then((files) => {
        console.log("all done", files)
        /* if not authenticated or offline, wait for these 2 conditions */
        defer(() => {
          attach(files)
        })
      })
      .catch((e) => {
         console.error(e)
      })
  }
})
